import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { useRef, useState, useEffect } from 'react';
import { FieldRound } from './field-round.js';
import { useDevice } from '../../../contexts/DeviceContext.js';
import { cn } from '../../../lib/utils.js';
import { NativeSelect, NativeSelectOption } from '../input/native-select.js';

const PhoneField = ({
  id,
  prefixSelect,
  prefixInput,
  middleInput,
  lastInput,
  error,
  disabled,
  readOnly,
  selectOption = [
    {
      value: "010",
      label: "010"
    },
    {
      value: "010",
      label: "010"
    }
  ]
}) => {
  const { isDesktop } = useDevice();
  const rootRef = useRef(null);
  const [title, setTitle] = useState("");
  useEffect(() => {
    const root = rootRef.current;
    if (!root) return;
    const Field = root.closest('[data-slot="field"]');
    const labelField = Field?.querySelector('[data-slot="field-label"]');
    const labelText = labelField?.querySelector(".label-text");
    if (!labelText) return;
    const clone = labelText.cloneNode(true);
    clone.querySelectorAll('[role="group"]').forEach((el) => el.remove());
    const text = clone.textContent?.trim() ?? "";
    console.log(clone);
    setTitle(text);
  }, []);
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(
    "div",
    {
      ref: rootRef,
      id,
      className: "flex items-center gap-2",
      role: "group",
      children: [
        prefixSelect && /* @__PURE__ */ jsx(
          NativeSelect,
          {
            ...prefixSelect,
            title: disabled ? `${title} 앞자리` : `${title} 앞자리 선택`,
            className: cn(
              "w-[100px]",
              readOnly && "readOnly",
              isDesktop && "w-[170px]"
            ),
            disabled,
            isValid: error,
            children: selectOption.map((opt) => /* @__PURE__ */ jsx(NativeSelectOption, { value: opt.value, children: opt.label }, opt.value))
          }
        ),
        prefixInput && /* @__PURE__ */ jsx(
          FieldRound,
          {
            id: "field-text",
            className: cn(
              "w-[100px]",
              error && "!border-interactive-danger !shadow-[inset_0_0_0_1px_var(--color-border-interactive-danger)]",
              isDesktop && "w-[170px]"
            ),
            maxLength: 4,
            title: disabled ? `${title} 앞자리` : `${title} 앞자리 입력`,
            inputMode: "numeric",
            ...prefixInput,
            disabled,
            readOnly
          }
        ),
        /* @__PURE__ */ jsx(
          FieldRound,
          {
            id: "field-text",
            className: cn(
              "w-[calc(50%-50px)]",
              error && "!border-interactive-danger !shadow-[inset_0_0_0_1px_var(--color-border-interactive-danger)]"
            ),
            maxLength: 4,
            title: disabled ? `${title} 중간자리 4자리` : `${title} 중간자리 4자리 입력`,
            inputMode: "numeric",
            ...middleInput,
            disabled,
            readOnly
          }
        ),
        /* @__PURE__ */ jsx(
          FieldRound,
          {
            id: "field-text",
            className: cn(
              "w-[calc(50%-50px)]",
              error && "!border-interactive-danger !shadow-[inset_0_0_0_1px_var(--color-border-interactive-danger)]"
            ),
            maxLength: 4,
            title: disabled ? `${title} 마지막자리 4자리` : `${title} 마지막자리 4자리 입력`,
            inputMode: "numeric",
            ...lastInput,
            disabled,
            readOnly
          }
        )
      ]
    }
  ) });
};

export { PhoneField };
